<template>
    <container>
        <h1>Our people are our strength.</h1>
        <span>
            MIT Services is staffed with a team of engineers, administrators, architects
            and consultants in a wide range of skillsets that assist each other and
            our clients in all stages of our projects.
        </span>
        <row :justify="'around'" :align="'center'">
            <column class="card" v-for="(item, index) in staff" :key="index" :width="2/5">
                <row :justify="'center'" :align="'stretch'">
                    <div class="image" v-lazy:background-image="item.image" />
                    <div class="line" />
                    <div class="text" >
                        <h3> {{ item.name }} </h3>
                        <h4> {{ item.role }} </h4>
                    </div>
                </row>
            </column>
        </row>
    </container>
</template>

<script>
import { staff } from '../../assets';
export default {
    name: 'StaffProfiles',
    data() {
        return {
            staff
        }
    }
}
</script>

<style scoped>
    .text {
        text-align: left;
    }
    .text > h3 {
        color: rgb(4, 114, 148);
    }
    .text > h4 {
        color: rgb(25, 25, 25);
    }
    .image {
        box-shadow: 0 0 1em black;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }
    .card {
        margin: 2em 0;
        background-color: rgba( 240, 240, 240, 0.7 );
        border-radius: 0.25em;
    }
    @media (orientation: landscape) and (min-width: 1281px) {
        .card {
            padding: 2em;
        }
        .text {
            padding-left: 1em;
            border-left: 1px solid black;
            margin-left: 1em;
            width: 70%;
        }
        .image {
            width: 20%;
        }
    }
    @media (orientation: portrait), (max-width: 1280px) {
        .image {
            width: 50%;
        }
        .text {
            width: 45%;
            padding-left: 1%;
            border-left: 1px solid black;
            margin-left: 1%;
        }
        .card {
            padding: 1%;
        }
    }
</style>